var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-list-item__meta" },
    [
      _c(
        "div",
        { staticClass: "session-list-item__meta__stream_title ui-title" },
        [_vm._v(_vm._s(_vm.streamTitle))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-list-item__meta__header" },
        [
          !_vm.session.uri.includes("@web.rec")
            ? _c("ui-button", {
                class: { active: _vm.isFavoriteReady },
                attrs: {
                  disabled: !_vm.isFavoriteReady,
                  icon:
                    (_vm.session.contact.favorite ? "fa" : "fal") +
                    " fa-star fa-fw",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggleFavorite", _vm.session)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "session-list-item__meta__header__title" }, [
            _vm.session.name || _vm.session.contact.name
              ? _c(
                  "div",
                  {
                    staticClass:
                      "session-list-item__meta__header__title__name ui-subheading",
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.session.name
                            ? _vm.session.name
                            : _vm.session.contact.name
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "session-list-item__meta__header__title__uri",
                class:
                  _vm.session.name || _vm.session.contact.name
                    ? "ui-caption"
                    : "ui-subheading",
                style: [
                  !_vm.session.name && !_vm.session.contact.name
                    ? { lineHeight: "40px" }
                    : {},
                ],
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(_vm.session.uri) + "\n\t\t\t")]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-list-item__meta__content" },
        [
          _vm.session.established === 0
            ? _c(
                "div",
                { staticClass: "session-list-item__meta__content__connecting" },
                [
                  _c("div", { staticClass: "ui-title" }, [
                    _vm._v("Connecting..."),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.session.established === 1
            ? _c("dynamic-duration", {
                staticClass: "ui-display-2",
                attrs: { duration: _vm.session.duration },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ui-button", {
            attrs: {
              icon: "fas fa-square",
              large: "",
              raised: "",
              secondary: "",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("stop", _vm.session)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.session.established === 0
        ? _c("ui-progress", { attrs: { stroke: 2, type: "bar" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-list-item__meta__footer" },
        [
          _vm.session.stream_id
            ? _c("div", { staticClass: "ui-subheading" }, [
                _vm._v("Stream input"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "session-list-item__meta__footer__stream_input" },
            [
              _c("div", [_vm._v("Bandwidth")]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.session.bw) + " kbit/s")]),
              _vm._v(" "),
              _c("div", [_vm._v("Audio packet loss")]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.session.audio.loss) + "%")]),
              _vm._v(" "),
              _c("div", [_vm._v("Video packet loss")]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.session.video.loss) + "%")]),
            ]
          ),
          _vm._v(" "),
          _vm.session.stream_id
            ? _c("div", { staticClass: "ui-subheading" }, [
                _vm._v("Stream output"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.session.stream_id
            ? _c(
                "div",
                {
                  staticClass: "session-list-item__meta__footer__stream_output",
                },
                [
                  _c("div", [_vm._v("Current viewers")]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.streamViewers))]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.session.stream_id
            ? _c("ui-clipboard-input", {
                staticClass: "session-list-item__meta__footer__link",
                attrs: {
                  hint: "Link copied to clipboard",
                  label: "Live stream link",
                },
                model: {
                  value: _vm.link,
                  callback: function ($$v) {
                    _vm.link = $$v
                  },
                  expression: "link",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }